import { render, staticRenderFns } from "./saldiscountrecimp.vue?vue&type=template&id=dedda1d6&scoped=true&"
import script from "./saldiscountrecimp.vue?vue&type=script&lang=js&"
export * from "./saldiscountrecimp.vue?vue&type=script&lang=js&"
import style0 from "./saldiscountrecimp.vue?vue&type=style&index=0&id=dedda1d6&lang=scss&scoped=true&"
import style1 from "./saldiscountrecimp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedda1d6",
  null
  
)

export default component.exports